import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QDialog from "../dialog/QDialog.js";
import QMenu from "../menu/QMenu.js";
import AnchorMixin from "../../mixins/anchor.js";
import { slot } from "../../utils/slot.js";
import AttrsMixin from "../../mixins/attrs.js";
import ListenersMixin from "../../mixins/listeners.js";
export default Vue.extend({
  name: 'QPopupProxy',
  mixins: [AttrsMixin, ListenersMixin, AnchorMixin],
  props: {
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  data: function data() {
    var breakpoint = parseInt(this.breakpoint, 10);
    return {
      type: this.$q.screen.width < breakpoint || this.$q.screen.height < breakpoint ? 'dialog' : 'menu'
    };
  },
  computed: {
    parsedBreakpoint: function parsedBreakpoint() {
      return parseInt(this.breakpoint, 10);
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        hide: this.__onHide
      });
    }
  },
  watch: {
    '$q.screen.width': function $qScreenWidth(width) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(width, this.$q.screen.height, this.parsedBreakpoint);
      }
    },
    '$q.screen.height': function $qScreenHeight(height) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(this.$q.screen.width, height, this.parsedBreakpoint);
      }
    },
    breakpoint: function breakpoint(_breakpoint) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(this.$q.screen.width, this.$q.screen.height, parseInt(_breakpoint, 10));
      }
    }
  },
  methods: {
    toggle: function toggle(evt) {
      this.$refs.popup.toggle(evt);
    },
    show: function show(evt) {
      this.$refs.popup.show(evt);
    },
    hide: function hide(evt) {
      this.$refs.popup.hide(evt);
    },
    __onHide: function __onHide(evt) {
      this.__updateType(this.$q.screen.width, this.$q.screen.height, this.parsedBreakpoint);

      this.$emit('hide', evt);
    },
    __updateType: function __updateType(width, height, breakpoint) {
      var type = width < breakpoint || height < breakpoint ? 'dialog' : 'menu';

      if (this.type !== type) {
        this.type = type;
      }
    }
  },
  render: function render(h) {
    var def = slot(this, 'default');
    var props = this.type === 'menu' && def !== void 0 && def[0] !== void 0 && def[0].componentOptions !== void 0 && def[0].componentOptions.Ctor !== void 0 && def[0].componentOptions.Ctor.sealedOptions !== void 0 && ['QDate', 'QTime', 'QCarousel', 'QColor'].includes(def[0].componentOptions.Ctor.sealedOptions.name) ? {
      cover: true,
      maxHeight: '99vh'
    } : {};
    var data = {
      ref: 'popup',
      props: _objectSpread(_objectSpread({}, props), this.qAttrs),
      on: this.onEvents
    };
    var component;

    if (this.type === 'dialog') {
      component = QDialog;
    } else {
      component = QMenu;
      data.props.target = this.target;
      data.props.contextMenu = this.contextMenu;
      data.props.noParentEvent = true;
      data.props.separateClosePopup = true;
    }

    return h(component, data, def);
  }
});